import { Injectable, Inject, Injector } from "@angular/core";
import { MdDialog, MdDialogConfig, MdDialogRef } from "@angular/material";
import { Observable } from 'rxjs';
import { AppModule } from "app/app.module";
import { LoadingComponent } from "../shared/component/loading.component";

@Injectable()
export class LoadingService {
    _loading: MdDialog;
    close: boolean = false;
    obj: MdDialogRef<LoadingComponent>;
    constructor() {
        this._loading = AppModule.injector.get(MdDialog);
    }

    carregar(texto = "Aguarde, carregando os dados...", aguardar = true) {
        this.close = false;
        if (aguardar)
            setTimeout(() => {
                if (!this.close) {
                    this.open(texto);
                }
            }, 500);
        else
            this.open(texto);
    }

    open(texto) {
        let config = new MdDialogConfig();
        config.hasBackdrop = true;
        config.disableClose = true;
        config.data = texto;
        this.obj = this._loading.open(LoadingComponent, config);
    }

    fecharTodos() {
        this.close = true;
        this._loading.closeAll();
    }

    fechar() {
        this.close = true;
        if (this.obj) this.obj.close();
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/services/loading.service.ts